import { useQuery, type QueryFunctionContext } from "@tanstack/react-query";
import { configuration } from "src/configuration";
import { UserFeedbackType, type UserFeedbackDto } from "src/http/types";
import { v4 as newGuid } from "uuid";
import { queryKeys } from "../queryKeys";
import { UrlUtilities, type QueryParams } from "../utilities";

const useGetGivenFeedback = (userId: string, queryParams?: QueryParams) => {
  // const { getAccessToken } = useAccessToken();

  async function getGivenFeedbackRequest({
    queryKey,
  }: QueryFunctionContext<ReturnType<typeof queryKeys.userFeedback.getGivenFeedback>>): Promise<UserFeedbackDto[]> {
    // const accessToken = await getAccessToken();
    const [{ userId, queryParams }] = queryKey;

    const url = new URL(`${configuration.apiRootUrl}/userFeedback/${userId}`);
    UrlUtilities.appendQueryParams(url, queryParams);

    // const response = await fetch(url.href, {
    //   headers: {
    //     Authorization: `Bearer ${accessToken}`,
    //   },
    // });

    // if (!response.ok) {
    //   throw new FetchError(response);
    // }

    // return response.json();

    const results: UserFeedbackDto[] = [
      {
        feedbackGuid: newGuid(),
        title: "Given 1",
        type: UserFeedbackType.Peer,
        isDraft: false,
        isReviewedByRecipient: true,
        isReviewedInOneOnOne: true,
        givenByUser: {
          displayName: "Garrett Samm",
          userId: "12345",
        },
        submittedDateTimeUtc: "2026-04-26T10:00:00",
        createdDateTimeUtc: "2026-04-26T10:00:00",
      },
      {
        feedbackGuid: newGuid(),
        title: "Given 2",
        type: UserFeedbackType.Performance,
        isDraft: false,
        isReviewedByRecipient: true,
        isReviewedInOneOnOne: false,
        givenByUser: {
          displayName: "Garrett Samm",
          userId: "12345",
        },
        submittedDateTimeUtc: "2026-04-26T10:00:00",
        createdDateTimeUtc: "2026-05-26T09:15:00",
      },
    ];

    return results;
  }

  return useQuery({
    queryKey: queryKeys.userFeedback.getGivenFeedback(userId, queryParams),
    queryFn: getGivenFeedbackRequest,
  });
};

export { useGetGivenFeedback };
